/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateOrderDetailsCommand } from '../../models/update-order-details-command';
import { UpdateOrderDetailsCommandResult } from '../../models/update-order-details-command-result';

export interface ApiNurseryManagerOrderDetailsUpdateOrderDetailsPatch$Params {
      body?: UpdateOrderDetailsCommand
}

export function apiNurseryManagerOrderDetailsUpdateOrderDetailsPatch(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerOrderDetailsUpdateOrderDetailsPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateOrderDetailsCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerOrderDetailsUpdateOrderDetailsPatch.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateOrderDetailsCommandResult>;
    })
  );
}

apiNurseryManagerOrderDetailsUpdateOrderDetailsPatch.PATH = '/api/NurseryManager/OrderDetails/UpdateOrderDetails';
